import React, { useMemo } from 'react';
import { Formik } from 'formik';
import ProfileSettlementDetailsForm, {
    SettlementDetailsValues,
    validateSettlementDetails,
} from './profile-settlement-details-form';
import PbFormikObserver from './PbFormikObserver';

interface Props {
    settlementDetails: Partial<SettlementDetailsValues>;
    onChange: (values: SettlementDetailsValues & ValidForValues) => void;
    internalManager: boolean;
}

interface ValidForValues {
    _valid: boolean;
}

const DEFAULT_VALUES: SettlementDetailsValues = {
    useSettlement: true,
    holder: '',
    iban: '',
    bic: '',
    useEmail: true,
    emailAddress: '',
    creditNotesEnabled: true,
};

function ProfileSettlementDetailsFormWrapper(props: Readonly<Props>) {
    const initialValues: SettlementDetailsValues = useMemo(() => ({
        ...DEFAULT_VALUES,
        ...props.settlementDetails,
    }), [props.settlementDetails]);

    return (
        <Formik
            initialValues={initialValues}
            validate={validateSettlementDetails}
            onSubmit={props.onChange}
        >
            {renderContent}
        </Formik>
    );

    function renderContent() {
        return (
            <>
                <PbFormikObserver onChange={props.onChange} />
                <ProfileSettlementDetailsForm
                    internalManager={props.internalManager}
                />
            </>
        );
    }
}

export default ProfileSettlementDetailsFormWrapper;
